import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import AddIcon from '@mui/icons-material/Add';
import LockResetIcon from '@mui/icons-material/LockReset';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CancelIcon from '@mui/icons-material/Cancel';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Divider from '@mui/material/Divider';
import { Tooltip } from "@mui/material";
import { logout } from "actions/auth";
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import colors from "assets/mavric-theme/base/colors.js";
import typography from "assets/mavric-theme/base/typography";
import borders from "assets/mavric-theme/base/borders";
const { primary, secondary, text, tableRow, transparent, white } = colors;
const { size } = typography;
const { borderRadius } = borders;
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
import MaterialReactTable from 'material-react-table';
import { getAllUsers, getWohlerUserRoles, deleteAdminPortalUser } from 'apis/CustomersApis';
import AddUserDialog from './AddUserDialog';
import MonitorUserResetPassword from './MonitorUserResetPassword';
import { Dialog, DialogActions, DialogContent, DialogTitle, Select, DialogContentText } from '@mui/material';
import { resolve } from 'path';
import EditUserDialog from './EditUserDialog';

const PortalUserManagement = () => {
    const columns = useMemo(
        () => [

            {
                header: 'Email',
                accessorKey: 'email',
                filter: 'equals',
                id: 'email',
                size: 150,
                Filter: ({ header }) => (
                    <Autocomplete
                        size="small"
                        options={emailOptions}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option}
                        renderOption={(props, option, { selected }) => (
                            <MenuItem {...props} sx={{ "&.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus": { backgroundColor: `${tableRow.hover} !important` } }}> {option}</MenuItem>
                        )}
                        style={{ width: 150 }}
                        renderInput={(params) => (
                            <TextField {...params} variant="outlined" placeholder="Email" />
                        )}
                        sx={{ '& .MuiAutocomplete-popupIndicator, & .MuiSvgIcon-root': { color: secondary.main } }}
                        onChange={(event, value) =>
                            header.column.setFilterValue(value)}
                        clearIcon={<HighlightOffIcon fontSize="small" />}
                        ListboxProps={{
                            sx: {
                                maxHeight: ITEM_HEIGHT * 4.5,
                            }
                        }}
                    />
                ),
                filterFn: 'emailFilterFn',

            },
            {
                accessorKey: 'role',
                header: 'Role Type',
                id: 'role',
                size: 120,
                Filter: ({ header }) => (
                    <Autocomplete
                        size="small"
                        options={roleNameOptions}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option}
                        renderOption={(props, option, { selected }) => (
                            <MenuItem {...props} sx={{ "&.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus": { backgroundColor: `${tableRow.hover} !important` } }}> {option} </MenuItem>
                        )}
                        style={{ width: 140 }}
                        renderInput={(params) => (
                            <TextField {...params} variant="outlined" placeholder="Role" />
                        )}
                        sx={{ '& .MuiAutocomplete-popupIndicator, & .MuiSvgIcon-root': { color: secondary.main } }}
                        onChange={(event, value) =>
                            header.column.setFilterValue(value)}
                        clearIcon={<HighlightOffIcon fontSize="small" />}
                        ListboxProps={{ sx: { maxHeight: ITEM_HEIGHT * 4.5, } }}
                    />
                ),
                filterFn: 'roleNameFilterFn',

            },

            {
                accessorKey: 'first_name',
                header: 'First Name',
                size: 150,
                enableColumnFilter: true,
                Filter: ({ header }) => (
                    <Autocomplete
                        size="small"
                        options={firstNameOptions}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option}
                        renderOption={(props, option, { selected }) => (
                            <MenuItem {...props} sx={{ "&.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus": { backgroundColor: `${tableRow.hover} !important` } }}> {option}</MenuItem>
                        )}
                        style={{ width: 150 }}
                        renderInput={(params) => (
                            <TextField {...params} variant="outlined" placeholder="First Name" />
                        )}
                        sx={{ '& .MuiAutocomplete-popupIndicator, & .MuiSvgIcon-root': { color: secondary.main } }}
                        onChange={(event, value) =>
                            header.column.setFilterValue(value)}
                        clearIcon={<HighlightOffIcon fontSize="small" />}
                        ListboxProps={{
                            sx: {
                                maxHeight: ITEM_HEIGHT * 4.5,
                            }
                        }}
                    />
                ),
                filterFn: 'firstNameFilterFn',

            },
            {
                accessorKey: 'last_name',
                header: 'Last Name',
                size: 150,
                enableColumnFilter: false,
                Filter: ({ header }) => (
                    <Autocomplete
                        size="small"
                        options={lastNameOptions}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option}
                        renderOption={(props, option, { selected }) => (
                            <MenuItem {...props} sx={{ "&.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus": { backgroundColor: `${tableRow.hover} !important` } }}> {option}</MenuItem>
                        )}
                        style={{ width: 150 }}
                        renderInput={(params) => (
                            <TextField {...params} variant="outlined" placeholder="Last Name" />
                        )}
                        sx={{ '& .MuiAutocomplete-popupIndicator, & .MuiSvgIcon-root': { color: secondary.main } }}
                        onChange={(event, value) =>
                            header.column.setFilterValue(value)}
                        clearIcon={<HighlightOffIcon fontSize="small" />}
                        ListboxProps={{
                            sx: {
                                maxHeight: ITEM_HEIGHT * 4.5,
                            }
                        }}
                    />
                ),
                filterFn: 'lastNameFilterFn',

            },
            {
                accessorKey: 'created_by',
                header: 'Created By',
                size: 150,
                enableColumnFilter: false,
                Cell: ({ cell }) => {
                    const value = cell.getValue();
                    return value ? value : '-';
                },
                enableSorting: true
            },
            {
                accessorKey: 'last_access_time',
                header: 'Last Access Time',
                size: 150,
                enableColumnFilter: false,
                Cell: ({ cell }) => {
                    const value = cell.getValue();
                    return value ? new Date(value).toLocaleString() : '-';
                },
                enableSorting: true
            },

        ],
        [],
    );
    const [allUsers, setAllUsers] = useState([]);
    // const [userIdOptions, setUserIdOptions] = useState([]);
    const [emailOptions, setEmailOptions] = useState([]);
    const [roleNameOptions, setRoleNameOptions] = useState([]);
    const [firstNameOptions, setFirstNameOptions] = useState([]);
    const [lastNameOptions, setLastNameOptions] = useState([]);
    const [openAddUserDialog, setOpenAddUserDialog] = useState(false);
    const [processing, setProcessing] = useState(false);
    const dispatch = useDispatch();
    const history = useHistory();
    const MyStateRole = useSelector(state => state.role);
    const UserId = useSelector(state => state.userid);
    const RoleId = useSelector(state => state.roleId);
    const Token = useSelector(state => state.accessToken);
    const isAccounting = (MyStateRole === "accounting") ? true : false;
    const isSalesOperator = (MyStateRole === "salesoperator") ? true : false;
    const isSalesAdmin = (MyStateRole === "salesadmin") ? true : false;
    const isSupport = (MyStateRole === "support") ? true : false;
    const isDealerAdmin = (MyStateRole === "dealeradmin") ? true : false;
    const isDealerOperator = (MyStateRole === "dealeroperator") ? true : false;
    const [tableKey, setTableKey] = useState(() => `user-table-${Date.now()}`);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [wohlerUserRoleList, setWohlerUserRoleList] = useState([]);
    const [openResetPassword, setOpenChangePassword] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
    const [deleteMessageConfirm, setDeleteMessageConfirm] = useState("");
    const [deleteMessageConfirmTitle, setDeleteMessageConfirmTitle] = useState("");
    const [alertState, setAlertState] = useState({ openAlert: false, alertSeverity: "error", alertMessage: "", vertical: 'bottom', horizontal: 'left' });
    const { vertical, horizontal } = alertState;
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);
    const [deleteAlertMsg, setDeleteAlertMsg] = useState("");
    const [pageAlertType, setPageAlertType] = useState("error");
    const [selectedRowId, setSelectedRowId] = useState(null);

    const [openDialog, setOpenDialog] = useState(false);

    // console.log("selectedRow", selectedRow);
    // console.log("selected row id: ", selectedRowId );


    const getAllUserData = async () => {
        try {
            setProcessing(true);
            const response = await getAllUsers();
            // console.log("getAllUserData::", response);

            if (response.length > 0) {
                setAllUsers(response);
                return response;
            } else {
                setAllUsers([]);
            }
        } catch (error) {
            setProcessing(false);
            setAllUsers([]);

            let errMessage = '';
            if (error.response) {
                errMessage = error.response.data.message;
                if (error.response.status === 401 || error.response.status === 403) {
                    const jsonPostMsg = {
                        user_id: UserId,
                        access_token: Token,
                        role_id: RoleId
                    };
                    dispatch(logout(jsonPostMsg));
                    history.push('/login');
                }
            } else if (error.request) {
                errMessage = String(error);
                console.error('Request error:', error.request);
            } else {
                errMessage = error.message;
                console.error('Error:', error.message);
            }

            throw new Error(errMessage);
        } finally {
            setProcessing(false);
        }
    };

    const getWohlerUserRolesData = async () => {
        try {
            setProcessing(true);
            const res = await getWohlerUserRoles();
            setWohlerUserRoleList(res);
            return res;

        } catch (error) {
            setProcessing(false);
            setWohlerUserRoleList([]);

            let errMessage = "";
            if (error.response) {
                errMessage = error.response.data.message;
                if (error.response.status === 401 || error.response.status === 403) {
                    const jsonPostMsg = {
                        user_id: UserId,
                        access_token: Token,
                        role_id: RoleId
                    };
                    dispatch(logout(jsonPostMsg));
                    history.push('/login');
                }
            } else if (error.request) {
                errMessage = String(error);
                console.error('Request error:', error.request);
            } else {
                errMessage = error.message;
                console.error('Error:', error.message);
            }
            throw new Error(errMessage);
        }
    };

    const prepareMonUserData = (data) => {
        let updtdEmailOptions = emailOptions;
        let updtdFNameOptions = firstNameOptions;
        let updtdLNameOptions = lastNameOptions;
        let updtdRoleNameOptions = roleNameOptions;

        data.map(row => {

            // Required Fields
            const isDuplicateEmail = updtdEmailOptions.includes(row.email);
            const isDuplicateRoleName = updtdRoleNameOptions.includes(row.role);
            if (!isDuplicateEmail) {
                updtdEmailOptions.push(row.email);
            }

            if (!isDuplicateRoleName) {
                updtdRoleNameOptions.push(row.role);
            }

            if (row.first_name.trim().length > 0) {
                const isDuplicateFirstName = updtdFNameOptions.includes(row.first_name);
                if (!isDuplicateFirstName) {
                    updtdFNameOptions.push(String(row.first_name));
                }
            }

            if (row.last_name.trim().length > 0) {
                const isDuplicateLastName = updtdLNameOptions.includes(row.last_name);
                if (!isDuplicateLastName) {
                    updtdLNameOptions.push(String(row.last_name));
                }
            } else { updtdLNameOptions.push(""); }
        });
        setEmailOptions(updtdEmailOptions.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })));
        setFirstNameOptions(updtdFNameOptions.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })));
        setLastNameOptions(updtdLNameOptions.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })));
        setRoleNameOptions(updtdRoleNameOptions.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })));
    };

    useEffect(() => {
        if (Array.isArray(allUsers) && allUsers.length > 0) {
            prepareMonUserData(allUsers);
        }
    }, [allUsers]);

    useEffect(() => {
        setTableKey(`user-table-${Date.now()}`);
    }, [allUsers]);


    const handlePasswordOpenForm = (row) => {
        // let newUserInfo = prepareUserInfo(row);
        // setUserInfo(newUserInfo);
        setSelectedRow(row);
        setOpenChangePassword(true);
        setSelectedUsers(row);
    };

    const handlePasswordCloseForm = () => {
        setOpenChangePassword(false);
        setSelectedRow(null);
        // setUserInfo(initialUserInfo);
        // setSelectedUsers([]);
    };

    const handleAddUserOpenDialog = () => {
        setOpenAddUserDialog(true);
    };

    const handleAddUserCloseDialog = async () => {
        setOpenAddUserDialog(false);
        await getAllUserData();
    };

    const resetSelection = () => {
        setSelectedRowId(null);
    };

    const handleEditRow = (row) => {
        setSelectedRow(row);
        setOpenDialog(true);
    };

    const handleUpdateCloseDialog = () => {
        setOpenDialog(false);
        setSelectedRow(null)
    };


    const handleDeleteRow = (row) => {
        setSelectedRow(row);
        setSelectedUsers(row);
        // const userEmail = row.email || '';
        const userIdentifier = row.email
            ? (row.first_name ? `${row.first_name} (${row.email})` : row.email)
            : '';
        let strMsg = `Are you sure you want to delete ${userIdentifier}?`;
        setDeleteMessageConfirm(strMsg);
        setDeleteMessageConfirmTitle("Delete User");
        setConfirmDeleteOpen(true);
    };


    const handleDeleteYes = async () => {
        setConfirmDeleteOpen(false);
        if (selectedRow) {
            try {
                await deleteAdminPortalUser(selectedRow.user_id);
                await getAllUserData();
                setPageAlertType("success");
                setDeleteAlertMsg(`${selectedRow.first_name} ${selectedRow.last_name} has been deleted successfully`);
                setShowDeleteAlert(true);
            } catch (error) {
                setPageAlertType("error");
                setDeleteAlertMsg(`Failed to delete user: ${error.message}`);
                setShowDeleteAlert(true);
                console.error("Delete error:", error);
            }
        }
        setSelectedRow(null);
        setSelectedUsers([]);
    };

    const handleDeleteNo = () => {
        setSelectedUsers([]);
        setConfirmDeleteOpen(false);
    };

    const handleConfirmClose = () => {
        setConfirmDeleteOpen(false);
        setSelectedUsers([]);
    };

    const handleDeleteAlertClose = (event, reason) => {

        if (reason === 'clickaway') {
            return;
        }
        setAlertState({ ...alertState, openAlert: false });
        setShowDeleteAlert(false);

    }


    useEffect(() => {
        getAllUserData();
        getWohlerUserRolesData();
    }, []);

    return (
        <div>

            <Box sx={{
                backgroundColor: primary.main,
                padding: 2, borderRadius: 2,
            }}>

                <Button variant="contained" sx={{ ml: 0, mt: 2, mb: 2 }} color="secondary" aria-label="Add New User" onClick={handleAddUserOpenDialog}
                    endIcon={<AddIcon sx={{ backgroundColor: secondary.main }} size="small" />}>Add User
                </Button>
                <MaterialReactTable
                    key={tableKey}
                    columns={columns}
                    data={allUsers}
                    muiTableToolbarAlertBannerProps={{ sx: { display: 'none' } }}
                    muiTablePaperProps={{ sx: { boxShadow: 'none', backgroundColor: primary.main } }}
                    muiTableBodyRowProps={({ row }) => ({
                        hover: true,
                        sx: {
                            color: text.main,
                            align: 'center',
                            '&:nth-of-type(odd)': {
                                backgroundColor: tableRow.dark,
                                border: 0,
                            },
                            '&:nth-of-type(even)': {
                                background: tableRow.light,
                            },
                            // hide last border
                            '&:last-child td, &:last-child th': {
                                border: 0,
                            },
                            '&:hover td': {
                                background: tableRow.hover,
                            },
                        },
                    })}
                    muiTableBodyCellProps={{ sx: { border: 'none', color: text.main, align: 'center', boxShadow: 'none', padding: '8px' } }}
                    muiTableProps={{ sx: { backgroundColor: primary.main, color: text.main, boxShadow: 'none' } }}
                    muiTopToolbarProps={{ sx: { backgroundColor: primary.main, boxShadow: 'none', minHeight: 0 } }}
                    muiBottomToolbarProps={{ sx: { backgroundColor: primary.main, boxShadow: 'none' } }}
                    muiTableHeadRowProps={{ sx: { backgroundColor: primary.main, color: text.main, textAlign: 'center' }, }}
                    muiTableHeadCellProps={{ sx: { borderBottom: 0, verticalAlign: 'none', boxShadow: 'none', align: 'center', color: text.main, '& .MuiTableSortLabel-icon, .MuiTableSortLabel-root': { color: white, opacity: 1 }, } }}
                    enableColumnActions={false}
                    // enableColumnFilters={true}
                    // enableRowSelection={(isSupport || isDealerOperator) ? false : true}
                    // enableMultiRowSelection={false}
                    enableSelectAll={false}
                    enableRowActions
                    positionPagination="bottom"
                    enableToolbarInternalActions={false}
                    initialState={{
                        density: 'compact',
                        showColumnFilters: true,
                        boxShadow: 'none',
                        pagination: { pageSize: 10, pageIndex: 0, pageCount: -1, },
                    }}
                    positionActionsColumn="last"
                    muiTablePaginationProps={{
                        rowsPerPageOptions: [3, 5, 10, 15, 20],
                        sx: { color: text.main, '& p': { marginBottom: 0 }, '& .MuiSvgIcon-root': { color: text.main, }, }
                    }}
                    // onRowSelectionChange={handleRowSelectionChange} 
                    // state={{ rowSelection }}
                    renderTopToolbar={({ table }) => {
                        const handleDeleteMultiple = () => {
                            // handleDeleteRow();
                            table.getSelectedRowModel().flatRows.map((row) => {
                                //console.log("selectedOriginal", row);
                                setSelectedUsers(current => [...current, row.original]);

                            });
                        };

                        return (
                            <>
                                {(isAccounting || isSalesOperator || isSalesAdmin || isDealerAdmin) ?
                                    (<div style={{ backgroundColor: primary.main }}>

                                        {/* <Button
                                        color="secondary"
                                        disabled={table.getSelectedRowModel().flatRows.length > 1 || table.getSelectedRowModel().flatRows.length === 0}
                                        onClick={handleDeleteMultiple}
                                        variant="contained"
                                        size="small"
                                        sx={{ mr: 1, ml: 1, mb: 1 }}
                                    >
                                        Delete User
                                    </Button> */}
                                        {/* <Button onClick={resetMyFilters} mr={2} variant="contained"
                                        sx={{
                                            // border: 1, borderRadius:2, backgroundColor: secondary.main, borderColor: secondary.main,       
                                            '&:hover': {
                                                backgroundColor: secondary.main,
                                            }, mb: 1,
                                        }} color="secondary" size="small" startIcon={<RefreshIcon sx={{ backgroundColor: secondary.main }} size="small" />}>
                                        Reset Filters
                                    </Button> */}

                                    </div>) : (<></>)
                                }
                            </>
                        );
                    }}
                    renderRowActions={({ row }) => (
                        <div style={{ display: 'flex', flexWrap: 'nowrap', gap: '0.5rem' }}>
                            {(isAccounting || isSalesOperator || isSalesAdmin || isDealerAdmin || isSupport) ?
                                (<ButtonGroup variant="text" color="primary" size="small" aria-label="text primary button group">
                                    <Tooltip title="Reset password" aria-label="Reset password">
                                        <IconButton sx={{
                                            border: 1, borderRadius: 2, backgroundColor: secondary.main, borderColor: secondary.main, width: 30, height: 30,
                                            '&:hover': {
                                                backgroundColor: secondary.main,
                                            },
                                        }} color="text" size="small"
                                            onClick={() => {
                                                handlePasswordOpenForm(row.original)
                                            }}
                                        >
                                            {/* <VisibilityIcon style={{ backgroundColor: secondary.main }} size="small" /> */}
                                            <LockResetIcon style={{ backgroundColor: secondary.main }} size="small" />
                                        </IconButton>
                                    </Tooltip>
                                    &nbsp;&nbsp;
                                    <Tooltip title="Edit" aria-label="Edit Monitor User">
                                        <IconButton sx={{
                                            border: 1, borderRadius: 2, backgroundColor: secondary.main, borderColor: secondary.main,
                                            width: 30, height: 30,
                                            '&:hover': {
                                                backgroundColor: secondary.main,
                                            },
                                        }} color="text" size="small"
                                            onClick={() => {
                                                handleEditRow(row.original)
                                            }}
                                        >
                                            <EditIcon style={{ backgroundColor: secondary.main }} size="small" />
                                        </IconButton>
                                    </Tooltip>
                                    &nbsp;&nbsp;
                                    <Tooltip title="Delete" aria-label="Delete Monitor User">
                                        <IconButton sx={{
                                            border: 1, borderRadius: 2, backgroundColor: secondary.main, borderColor: secondary.main,
                                            width: 30, height: 30,
                                            '&:hover': {
                                                backgroundColor: secondary.main,
                                            },
                                        }} color="text" size="small"
                                            onClick={() => {
                                                handleDeleteRow(row.original)
                                            }}
                                        >
                                            <DeleteIcon style={{ backgroundColor: secondary.main }} size="small" />
                                        </IconButton>
                                    </Tooltip>
                                </ButtonGroup>
                                ) :
                                (<ButtonGroup variant="text" color="primary" size="small" aria-label="text primary button group">
                                    <Tooltip title="View" aria-label="Apply">
                                        <IconButton sx={{
                                            border: 1, borderRadius: 2, backgroundColor: secondary.main, borderColor: secondary.main, width: 30, height: 30,
                                            '&:hover': {
                                                backgroundColor: secondary.main,
                                            },
                                        }} color="text" size="small"
                                            onClick={() => {
                                                handleViewMonUserDetail(row.original)
                                            }}
                                        >
                                            <VisibilityIcon style={{ backgroundColor: secondary.main }} size="small" />
                                        </IconButton>
                                    </Tooltip>
                                </ButtonGroup>
                                )
                            }


                        </div>
                    )}

                    filterFns={{

                        emailFilterFn: (row, _columnIds, filterValue) => {
                            if (filterValue !== null) {
                                if (filterValue !== 'All') {
                                    return row.getValue('email') === filterValue;
                                } else {
                                    return true;
                                }
                            } else {
                                return true;
                            }
                        },

                        firstNameFilterFn: (row, _columnIds, filterValue) => {
                            if (filterValue !== null) {
                                if (filterValue !== 'All') {
                                    return String(row.getValue('first_name')) === filterValue;
                                } else {
                                    return true;
                                }
                            } else {
                                return true;
                            }
                        },

                        lastNameFilterFn: (row, _columnIds, filterValue) => {
                            if (filterValue !== null) {
                                if (filterValue !== 'All') {
                                    return row.getValue('last_name') === filterValue;
                                } else {
                                    return true;
                                }
                            } else {
                                return true;
                            }
                        },

                        roleNameFilterFn: (row, _columnIds, filterValue) => {
                            if (filterValue !== null) {
                                if (filterValue !== 'All') {
                                    return row.getValue('role') === filterValue;
                                } else {
                                    return true;
                                }
                            } else {
                                return true;
                            }
                        },
                    }}
                />
            </Box>

            <AddUserDialog
                open={openAddUserDialog}
                onClose={handleAddUserCloseDialog}
                userRoleList={wohlerUserRoleList}
            />

            <Dialog
                open={openResetPassword}
                onClose={handlePasswordCloseForm}
                // fullScreen={fullScreen}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                sx={{
                    '& .MuiDialog-paper': {
                        backgroundColor: primary.main, p: 0
                    }
                }}
            >
                <DialogTitle>
                    <Typography variant="body2" color={secondary.main} sx={{ fontWeight: 600, mb: 2 }} gutterBottom>
                        {'Reset Password'}
                    </Typography>
                </DialogTitle>
                <DialogContent sx={{ p: 0 }}>
                    <MonitorUserResetPassword
                        bizUsrInfo={selectedRow}
                        isPortalUser={true}
                        // selectedCustomer={selectedCustomer}
                        // UserReset={false}
                        handleCloseForm={handlePasswordCloseForm}
                    />
                </DialogContent>
            </Dialog>

            <EditUserDialog
                openDialog={openDialog}
                handleUpdateCloseDialog={handleUpdateCloseDialog}
                selectedRow={selectedRow}
                userRoleList={wohlerUserRoleList}
                getAllUserData={getAllUserData}
            />

            <Dialog
                open={confirmDeleteOpen}
                onClose={handleConfirmClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth='md'
                sx={{
                    '& .MuiDialog-paper': {
                        backgroundColor: primary.main,
                    }
                }}
            >
                <DialogTitle id="alert-dialog-title">
                    <Typography fontSize={size.lg} color={secondary.main} sx={{ fontWeight: 600, }}>{deleteMessageConfirmTitle}</Typography>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">{deleteMessageConfirm}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="secondary" startIcon={<CancelIcon />}
                        onClick={handleDeleteNo}>No</Button>

                    <Button variant="contained" color="secondary" startIcon={<DeleteIcon />}
                        onClick={handleDeleteYes} autoFocus>Yes</Button>
                </DialogActions>
            </Dialog>


            <Snackbar
                anchorOrigin={{ vertical, horizontal }}
                open={showDeleteAlert}
                autoHideDuration={6000}
                key={vertical + horizontal}
                onClose={handleDeleteAlertClose}
            >
                <Alert elevation={6} variant="filled" onClose={handleDeleteAlertClose}
                    severity={pageAlertType || "error"} sx={{ "& .MuiAlert-message": { color: white.main, fontSize: size.sm }, marginBottom: 4 }}
                >
                    {deleteAlertMsg}
                </Alert>
            </Snackbar>
        </div>
    )
}

export default PortalUserManagement
